export const MATTER_LIST_TAB_ID = "1";

export const isTabOpen = (tabs, tabId) =>
  Boolean(tabId) && Array.isArray(tabs) && tabs.some((tab) => tab?.id === tabId);

// Which tab to activate once a matter's saved tabs are restored, or null to
// leave the active tab alone. A document named in the URL that is not among
// the open tabs belongs to the step that opens it: activating it here first
// leaves the viewer with no tab to load into, and the later activation is a
// no-op that never starts the viewer.
export const tabToActivateAfterRestore = (urlTabId, openTabIds) => {
  if (!urlTabId) return MATTER_LIST_TAB_ID;
  return openTabIds.includes(urlTabId) ? urlTabId : null;
};
